import appSettings from 'wanderu-config';

import ClientFacebookService from './ClientFacebookService';
import ServerFacebookService from './ServerFacebookService';

function _getTargetFacebookService() {
    return appSettings.env.isClient
        ? ClientFacebookService
        : ServerFacebookService;
}

async function getLoggedInState() {
    return _getTargetFacebookService().getLoggedInState();
}

async function logIn() {
    return _getTargetFacebookService().logIn();
}

async function logOut() {
    return _getTargetFacebookService().logOut();
}

async function getLoggedInUser() {
    return _getTargetFacebookService().getLoggedInUser();
}

export default {
    getLoggedInState,
    getLoggedInUser,
    logIn,
    logOut,
};
